import type { Notification } from '../../lib/types';
import { notificationDetailRows } from './notificationDetailRows';

/**
 * Righe di dettaglio sotto il messaggio della notifica (28/09/2026): gli stessi campi che la
 * mail mostra in tabella (metadata.email_details) e il riquadro descrizione (metadata.email_quote).
 * Le notifiche senza questi campi restano come prima.
 */
export function NotificationDetails({ metadata }: { metadata: Notification['metadata'] }) {
  const { rows, quote } = notificationDetailRows(metadata);
  if (rows.length === 0 && !quote) return null;

  return (
    <div className="mt-1.5 space-y-1">
      {rows.length > 0 && (
        <dl className="grid grid-cols-[auto_1fr] gap-x-2 gap-y-0.5 text-xs">
          {rows.map((r, i) => (
            <div key={i} className="contents">
              <dt className="text-muted-foreground whitespace-nowrap">{r.label}</dt>
              <dd className="text-foreground truncate" title={r.value}>{r.value}</dd>
            </div>
          ))}
        </dl>
      )}
      {quote && (
        <p className="text-xs text-muted-foreground bg-muted/50 rounded px-2 py-1 line-clamp-3 whitespace-pre-line">
          {quote}
        </p>
      )}
    </div>
  );
}
